import { Button, Group, Dialog } from '@economic/taco';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { t, useLocalization } from '../../../../../shared/components/l10n/l10n';
import LoadingBox from '../../../../home/PlanUpgradeDialog/LoadingBox';

export function ResendStatementOfAccount() {
    const textsLoading = useLocalization(textIds);
    const navigate = useNavigate();
    const location = useLocation();

    const hide = () => {
        navigate(location.pathname);
    };

    if (textsLoading) {
        return (
            <Dialog open={location.hash === '#resend-statementofaccount'} onClose={hide}>
                <Dialog.Content aria-label={t`POPUP_INVOICEETC_RESENDACCOUNTSTATEMENT`}>
                    <LoadingBox />
                </Dialog.Content>
            </Dialog>
        );
    }

    return (
        <Dialog open={location.hash === '#resend-statementofaccount'} onClose={hide}>
            <Dialog.Content aria-label={t`POPUP_INVOICEETC_RESENDACCOUNTSTATEMENT`}>
                <Dialog.Title>{t`POPUP_INVOICEETC_RESENDACCOUNTSTATEMENT`}</Dialog.Title>

                <p>{t`POPUP_RESEND_EMAIL_DEBTORCARD_ERROR_MESSAGE`}</p>

                <Dialog.Footer>
                    <Group>
                        <Button appearance="primary" onClick={hide}>{t`BUTTON_OK`}</Button>
                    </Group>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}

const textIds = ['BUTTON_OK', 'POPUP_INVOICEETC_RESENDACCOUNTSTATEMENT', 'POPUP_RESEND_EMAIL_DEBTORCARD_ERROR_MESSAGE'];
